<template>
  <div v-if="dialogVisible" class="fill-box" @mousewheel.prevent>
    <div class="alter-box">
      <div class="first" v-if="step_number == 1">
        <div>
          <img src="../assets/images/altercha.png" alt="" @click="closeModal" />
        </div>
        <p>请完善信息，平台将为您提供个性化的智能 推荐服务</p>
        <img class="chahua" src="../assets/images/chahua.png" alt="" srcset="" />
      </div>
      <div class="second" v-if="step_number == 2">
        <div class="chahao">
          <img src="../assets/images/alterlogo.png" alt="" />
          <img src="../assets/images/altercha.png" alt="" @click="closeModal" />
        </div>
        <div id="second">
          <div class="type-div city-div">
            <p><span id="asterisk">*</span>您的所在城市</p>
            <el-cascader
              ref="areaRef"
              v-model="partyAddressCode"
              :options="pcoptions"
              @change="handleChangeBussAddress($event)"
              placeholder="请选择所在城市"
            />
            <p id="tips" v-if="errors.area">{{ errors.area }}</p>
          </div>
          <div class="type-div service-div">
            <p><span id="asterisk">*</span>您或您的企业所属行业</p>
            <el-cascader
              v-model="form.type"
              :options="options"
              :show-all-levels="false"
              popper-class="word-div"
              placeholder="请选择"
              @change="HandTips"
            ></el-cascader>
            <p id="tips" v-if="errors.type">{{ errors.type }}</p>
          </div>
          <div class="type-div service-div">
            <p><span id="asterisk">*</span>您希望获得哪些方面的服务(多选)</p>
            <div id="service-id" ref="serviceId">
              <div
                v-for="(item, index) in serviceList"
                :key="index"
                @click="changeService(item)"
                :id="item.selected == true ? 'select-divs' : ''"
              >
                {{ item.text }}
              </div>
            </div>
            <p id="tips" v-if="errors.arrayerr">{{ errors.arrayerr }}</p>
          </div>
          <div class="type-div last-div">
            <p><span id="asterisk">*</span>您或您的企业目前的发展阶段</p>
            <div id="item-id" ref="itemId">
              <div id="select-div" @click="changeTime(0)">初创期</div>
              <div @click="changeTime(1)">业务扩张期</div>
              <div @click="changeTime(2)">稳定运营</div>
              <div @click="changeTime(3)">企业转型期</div>
            </div>
          </div>
        </div>
      </div>
      <div class="save">
        <button @click="changeStep">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAreaList, addInfo } from '@/api/login';
import { getCategoryList } from '@/api/tool/solution';
import { regionData, CodeToText } from 'element-china-area-data';
import { mapState, mapActions } from 'vuex';

// import 'path/to/custom-element-ui.css';
export default {
  name: 'FillInFrom',
  computed: {
    ...mapState(['showPopup']),
  },
  props: ['dialogVisible'],
  data() {
    return {
      title: '通知标题',
      message: '通知内容',
      step_number: 1,
      options: [],
      form: {
        type: '',
        newArray: [1],
        // 区县
        area: '',
        service: 1,
      },
      partyAddressCode: [],
      province: '',
      development_stage: 1,
      serviceList: [
        { id: 1, text: '行业解决方案', selected: true },
        { id: 2, text: '高精特新', selected: false },
        { id: 3, text: '工商财税', selected: true },
        { id: 4, text: 'IPO服务', selected: false },
        { id: 5, text: '金融服务', selected: false },
      ],
      pcoptions: regionData,
      tipstype: false,
      tipsarea: false,
      errors: {},
      fuwuerros: false,
      hasErrors: false,
      fillshowPopup: false,
    };
  },
  created() {
    this.getAreaOptions();
  },
  mounted() {
    this.fillshowPopup = this.$store.state.user.showPopup;
    this.getCateList();
    this.changeTime(0);
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    HandTips(value) {
      if (this.form.type !== '') {
        this.$delete(this.errors, 'type');
        const lastValue = value[value.length - 1];
        this.form.type = lastValue;
      }
    },
    changeStep() {
      // this.errors = {};
      this.step_number += 1;
      if (this.step_number == 3) {
        this.step_number = 2;
        this.errors = {}; // 清空之前的错误信息
        this.hasErrors = false;
        // 验证规则
        const rules = {
          type: [{ required: true, message: '请选择所属行业' }],
          area: [{ required: true, message: '请选择所在城市' }],
        };
        for (const fieldName in this.form) {
          const fieldValue = this.form[fieldName];
          const fieldRules = rules[fieldName];
          if (fieldRules) {
            for (const rule of fieldRules) {
              if (rule.required && fieldValue === '') {
                this.errors[fieldName] = rule.message;
                this.hasErrors = true;
              }
            }
            if (this.form.newArray.length === 0) {
              this.$set(this.errors, 'arrayerr', '请选择你所希望获得的服务');
            }
          }
        }
        // if (this.form.newArray == []) {
        //   this.fuwuerros = true;
        // }
        this.addInfolist();
      }
    },

    // 获取区域联动数据的方法
    getAreaData(data = { deep: 0, value: 100000 }) {
      return new Promise(resolve => {
        // 一级一级通过传上一级的编码获取到省市区的值（初始传100000）

        const params = {
          limit: 1000,
          ...this.formatQueryParams({
            pcode: { value: data.value, op: '=' },
          }),
        };
        console.log('----');
        getAreaList(params)
          .then(res => {
            resolve(res.data);
          })
          .catch(err => {});
      });
    },

    getAreaOptions() {
      // debugger;

      console.log('--');
      let _this = this;
      this.areaOptions = {
        // 根据组件文档所阐述的内容进行对应的懒加载
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          // 调用后端接口获取数据
          console.log('------');
          _this.getAreaData(node.data).then(data => {
            const nodes = data.map(item => ({
              leaf: level >= 2,
              label: item.name,
              value: item.code,
              level,
            }));
            resolve(nodes);
          });
        },
      };
    },
    handleChangeBussAddress(e) {
      this.province = e[0];
      this.form.service_position = e[1];
      this.form.area = e[2];
      let area = '';
      switch (e.length) {
        case 1:
          area += CodeToText[e[0]];
          break;
        case 2:
          area += CodeToText[e[0]] + ' ' + CodeToText[e[1]];
          break;
        case 3:
          area += CodeToText[e[0]] + ' ' + CodeToText[e[1]] + ' ' + CodeToText[e[2]];
          break;
        default:
          break;
      }
      console.log(this.form.service_position, 'this.form.service_position');
      this.form.addresss = area;
      if (this.form.area !== '') {
        this.$delete(this.errors, 'area');
      }
    },
    changeService(item) {
      item.selected = !item.selected;
      const array = this.serviceList.filter(item => item.selected).map(item => item.id);
      this.form.newArray = JSON.parse(JSON.stringify(array));
      if (this.form.newArray !== []) {
        this.$delete(this.errors, 'arrayerr');
      }
    },

    changeTime(index) {
      const itemIdElement = this.$refs.itemId;
      if (itemIdElement) {
        const divElements = itemIdElement.querySelectorAll('div');
        for (let i = 0; i < divElements.length; i++) {
          if (i == index) {
            divElements[i].id = 'select-div';
          } else {
            divElements[i].id = '';
          }
        }
        this.form.service = index + 1;
      }
    },
    getCateList() {
      const params = {
        id: 1,
      };
      getCategoryList(params).then(res => {
        const data = res.data.category;
        this.options = JSON.parse(JSON.stringify(data));
        this.options.forEach(item => {
          item.label = item.name;
          item.value = item.id;
          item.children = item.node;
          delete item.node;
          item.children.forEach(ite => {
            ite.label = ite.name;
            ite.value = ite.id;
          });
        });
      });
    },
    addInfolist() {
      if (!this.hasErrors) {
        const params = {
          category_id: this.form.type,
          development_stage: this.form.service,
          service: this.form.newArray,
          city: this.form.area,
        };
        addInfo(params).then(res => {
          this.$notify({
            title: '非常感谢，我们将根据您所填信息推荐精准内容',
            // message: '非常感谢，我们将根据您所填信息推荐精准内容',
            type: 'success',
          });
          this.$emit('close','mag');
          const h = this.$createElement;
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  padding: 0;
  margin: 0;
  list-style: none;
}
.modal-open {
  overflow: hidden;
}
.fill-box {
  z-index: 10;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
}
.alter-box {
  text-align: left;
  width: 620px;
  // height: 590px;
  background: white;
  border-radius: 10px;
  margin: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -10px;
  .type-div.city-div {
    margin-top: 15px;
    /deep/ .el-cascader {
      width: 100%;
      position: relative;
      font-size: 14px;
      line-height: 40px;
    }
  }
  #asterisk {
    color: red;
    margin-right: 5px;
  }
  #second {
    padding-left: 50px;
  }
  #tips {
    margin: 10px 0px 0px 0px;
    // margin: 0;
    padding: 0;
    list-style: none;
    font-size: 10px;
    color: red;
  }
  .first {
    margin: 48px 80px 0 80px;
    position: relative;
    div {
      position: absolute;
      top: -30px;
      right: -60px;
      cursor: pointer;
    }
    p {
      position: absolute;
      top: 35px;
      left: 10%;
      width: 381px;
      height: 27px;
      font-size: 16px;
      font-family: Microso;
    }
    .chahua {
      width: 460px;
      height: 460px;
    }
  }
  .second {
    // height: 380px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    width: 100%;
    // height: 510px;
    .chahao {
      width: calc(100% - 48px);
      background-image: url(../assets/images/weitu.png);
      height: 110px;
      background-size: cover;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 24px;
      img:last-child {
        cursor: pointer;
      }
    }
    .type-div {
      > p {
        text-align: left;
        font-size: 16px;
        font-family: MicrosoftYaHei;
        color: #050b1e;
        margin: 0 0 10px 0;
      }
      .select {
        width: 400px;
      }
    }
    .service-div {
      margin-top: 25px;
      cursor: pointer;
    }
    .service-div {
      > div {
        display: flex;
        justify-content: flex-start;
        > div {
          border-radius: 15px;
          border: 1px solid #e2e6ed;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          color: #999999;
          padding: 5px 11px;
          margin-right: 10px;
        }
        #select-divs {
          border: 1px solid #2a55a4;
          // background: #2a55a4;
          color: #2a55a4;
        }
      }
    }
    .last-div {
      margin: 25px 0;
      > div {
        display: flex;
        justify-content: flex-start;
        > div {
          color: #999999;
          background: #f9fafb;
          border-radius: 15px;
          border: none;
          font-size: 12px;
          font-family: MicrosoftYaHei;
          padding: 5px 11px;
          margin-right: 10px;
          cursor: pointer;
        }
        #select-div {
          background: #2a55a4;
          color: #ffffff;
        }
      }
    }
  }
  .save {
    padding-bottom: 50px;
    width: 100%;
    text-align: center;
    button {
      cursor: pointer;
      border: none;
      width: 400px;
      height: 60px;
      line-height: 60px;
      background: #2a55a4;
      border-radius: 4px;
      display: inline-block;
      font-size: 20px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FillInFrom.vue